import { Answer } from "./Answer";
import { Question } from "./Question";

export class Quiz
{
    private questions: Array<Question> = [];
    private currentQuestionIndex: number;

    constructor(questions: Array<Question>, private onQuizFinished: () => void)
    {
        this.questions = questions;
        this.currentQuestionIndex = -1;
    }

    public getCurrentQuestionNumber(): number
    {
        return this.currentQuestionIndex + 1;
    }

    public getNumberOfQuestions(): number
    {
        return this.questions.length;
    }

    public startQuiz(): void
    {
        this.currentQuestionIndex = 0;
    }

    public retryQuestion(): void 
    {
        this.selectedAnswers = [];
    }

    public getCurrentQuestion(): Question
    {
        const currentQuestion = this.questions[this.currentQuestionIndex];
        return currentQuestion;
    }

    public nextQuestion(): void
    {
        if (this.currentQuestionIndex < this.questions.length - 1)
        {
            this.selectedAnswers = [];
            this.currentQuestionIndex++;
        }
        else
        {
            this.onQuizFinished();
        }
    }

    private selectedAnswers: Array<Answer> = [];
    public checkAnswer(selectedAnswers: Answer[]): boolean
    {
        selectedAnswers.map(a => this.selectedAnswers.push(a));

        const question = this.questions[this.currentQuestionIndex];
        const correctAnswers = question.getAnswers().filter((answer) => answer.isAnswerCorrect());

        if (selectedAnswers.length !== correctAnswers.length)
        {
            return false;
        }

        for (const selectedAnswer of selectedAnswers)
        {
            if (!correctAnswers.some((correctAnswer) => correctAnswer === selectedAnswer))
            {
                return false;
            }
        }

        return true;
    }

    public getIncorrectSelectedAnswers(): Answer[]
    {
        const question = this.questions[this.currentQuestionIndex];
        const correctAnswers = question.getAnswers().filter((answer) => answer.isAnswerCorrect());

        const incorrectAnswers = this.selectedAnswers.filter((selectedAnswer) =>
        {
            return !correctAnswers.some((correctAnswer) => correctAnswer === selectedAnswer);
        });

        return incorrectAnswers;
    }

    public getIncorrectAnswers(): Answer[]
    {
        const question = this.questions[this.currentQuestionIndex];
        const inCorrectAnswers = question.getAnswers().filter((answer) => answer.isAnswerCorrect() === false);
        return inCorrectAnswers
    }
}